<template>
  <b-container>
    <b-modal
      ref="openModal"
      class="story"
      scrollable
      size="lg"
      title="Histórico"
    >
      <!-- {{ id }} -->
      <process-story :id="id"></process-story>

      <template #modal-footer="{ ok }">
        <div class="right">
          <b-button variant="green" @click="ok()"> Fechar </b-button>
        </div>
      </template>
    </b-modal>
  </b-container>
</template>
<script>
export default {
  name: "ProcessStoryModal",
  props: {},
  components: {
    ProcessStory: () =>
      import("@/components_rms/workflow/Process/ProcessStory.vue"),
  },
  data() {
    return {
      id: "",
    };
  },
  methods: {
    openModal(item) {
      this.$refs.openModal.show();
      this.id = item.toString();
    },
  },
};
</script>
